import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { ITeamSummaryApi } from '../models';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TeamDetailsService {
  private http = inject(HttpClient);
  private router = inject(Router);

  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingTeamDetails = signal<boolean>(false);
  isErrorTeamDetails = signal<boolean>(false);
  teamDetails = signal<ITeamSummaryApi | null>(null);

  constructor() {}

  getTeamDetails(
    teamId: string,
    callback?: () => void,
    isRefreshing: boolean = false
  ) {
    if (!isRefreshing) this.isLoadingTeamDetails.set(true);
    this.isErrorTeamDetails.set(false);

    this.http
      .get<ITeamSummaryApi | null>(
        `${this.env.baseUrlWeb}/teams/${teamId}/summary`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((err) => {
          this.isLoadingTeamDetails.set(false);
          this.isErrorTeamDetails.set(true);

          if (err.error.Code === 'TEAM_ERROR_009') {
            this.router.navigate(['/404']);
          }

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.isLoadingTeamDetails.set(false);
          this.teamDetails.set(null);
          return;
        }

        this.teamDetails.set(data);
        callback && callback();
        this.isLoadingTeamDetails.set(false);
        this.isErrorTeamDetails.set(false);
      });
  }
}
